export var ColorToken;
(function (ColorToken) {
    // Background tokens
    ColorToken["backgroundPrimary"] = "#FFFFFF";
    ColorToken["backgroundSecondary"] = "#00008F";
    ColorToken["backgroundPage"] = "#FAFAFA";
    ColorToken["backgroundTransparent"] = "transparent";
    ColorToken["backgroundInformation"] = "#F5F5FB";
    ColorToken["backgroundSuccess"] = "#FAFFFB";
    ColorToken["backgroundWarning"] = "#FDF8F6";
    ColorToken["backgroundError"] = "#FDF6F7";
    // Border tokens
    ColorToken["borderInteractive"] = "#999999";
    ColorToken["borderInteractiveDisabled"] = "#9999997A";
    ColorToken["borderInteractiveSelect"] = "#00008F";
    ColorToken["borderInteractiveHover"] = "#000072";
    ColorToken["borderOpaque"] = "#5F5F5F";
    ColorToken["borderInformation"] = "#00008F";
    ColorToken["borderSuccess"] = "#118635";
    ColorToken["borderWarning"] = "#C94E14";
    ColorToken["borderError"] = "#A11028";
    // Button tokens
    ColorToken["buttonPrimaryBackground"] = "#00008F";
    ColorToken["buttonPrimaryHoverBackground"] = "#000072";
    ColorToken["buttonPrimaryActiveBackground"] = "#3333A5";
    ColorToken["buttonSecondaryBorder"] = "#00008F";
    ColorToken["buttonSecondaryHoverBackground"] = "#00008F";
    ColorToken["buttonSecondaryActiveBackground"] = "#3333A5";
    ColorToken["buttonInverseBorder"] = "#FFFFFF";
    ColorToken["buttonInverseHoverBackground"] = "#FFFFFF";
    ColorToken["buttonInverseActiveBackground"] = "#E5E5E5";
    ColorToken["buttonBusinessBackground"] = "#D24723";
    ColorToken["buttonBusinessHoverBackground"] = "#A8391C";
    ColorToken["buttonBusinessActiveBackground"] = "#DF7E65";
    ColorToken["buttonValidationBackground"] = "#118635";
    ColorToken["buttonValidationHoverBackground"] = "#0E6B2A";
    ColorToken["buttonValidationActiveBackground"] = "#118635";
    ColorToken["buttonNeutralBackground"] = "#5F5F5F";
    ColorToken["buttonNeutralHoverBorder"] = "#333333";
    ColorToken["buttonNeutralActiveBorder"] = "#999999";
    ColorToken["buttonDisabledBackground"] = "#CCCCCC";
    // Icon tokens
    ColorToken["iconPrimary"] = "#00008F";
    ColorToken["iconSecondary"] = "#333333";
    ColorToken["iconOnColor"] = "#FFFFFF";
    ColorToken["iconPrimaryDisabled"] = "#00008F94";
    ColorToken["iconSecondaryDisabled"] = "#333333C4";
    ColorToken["iconInformation"] = "#00008F";
    ColorToken["iconSuccess"] = "#118635";
    ColorToken["iconWarning"] = "#C94E14";
    ColorToken["iconError"] = "#C91432";
    ColorToken["iconTertiary"] = "#5F5F5F";
    // Link tokens
    ColorToken["linkPrimary"] = "#00008F";
    ColorToken["linkPrimaryHover"] = "#000072";
    ColorToken["linkOnColor"] = "#FFFFFF";
    ColorToken["linkOnColorHover"] = "#B5D0EE";
    // Text tokens
    ColorToken["textPrimary"] = "#00008F";
    ColorToken["textSecondary"] = "#333333";
    ColorToken["textTertiary"] = "#5F5F5F";
    ColorToken["textPlaceholder"] = "#5F5F5F";
    ColorToken["textOnColor"] = "#FFFFFF";
    ColorToken["textDisabled"] = "#333333C4";
    ColorToken["textInformation"] = "#00008F";
    ColorToken["textSuccess"] = "#118635";
    ColorToken["textWarning"] = "#C94E14";
    ColorToken["textError"] = "#C91432";
    // Other tokens
    ColorToken["overlay"] = "#3333337A";
    ColorToken["divider01"] = "#E5E5E5";
    ColorToken["divider02"] = "#00008F";
})(ColorToken || (ColorToken = {}));
